export abstract class StringHelper {
  public static isNullOrWhiteSpace(str: string) {
    return str === undefined || str === null || str.match(/^ *$/) !== null;
  }
}
